var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 2.83317C0.666626 1.9127 1.41282 1.1665 2.33329 1.1665H5.66663C6.5871 1.1665 7.33329 1.9127 7.33329 2.83317V6.1665C7.33329 7.08698 6.5871 7.83317 5.66663 7.83317H2.33329C1.41282 7.83317 0.666626 7.08698 0.666626 6.1665V2.83317Z",
    stroke: "#A4A8B5",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 4.49984C17.3333 6.34079 15.8409 7.83317 14 7.83317C12.159 7.83317 10.6666 6.34079 10.6666 4.49984C10.6666 2.65889 12.159 1.1665 14 1.1665C15.8409 1.1665 17.3333 2.65889 17.3333 4.49984Z",
    stroke: "#A4A8B5",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33329 14.4998C7.33329 16.3408 5.84091 17.8332 3.99996 17.8332C2.15901 17.8332 0.666626 16.3408 0.666626 14.4998C0.666626 12.6589 2.15901 11.1665 3.99996 11.1665C5.84091 11.1665 7.33329 12.6589 7.33329 14.4998Z",
    stroke: "#A4A8B5",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 12.8332C10.6666 11.9127 11.4128 11.1665 12.3333 11.1665H15.6666C16.5871 11.1665 17.3333 11.9127 17.3333 12.8332V16.1665C17.3333 17.087 16.5871 17.8332 15.6666 17.8332H12.3333C11.4128 17.8332 10.6666 17.087 10.6666 16.1665V12.8332Z",
    stroke: "#A4A8B5",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIco);
export default __webpack_public_path__ + "static/media/dashboard-ico.4ca2272dba39b916f3548b766e4b4e07.svg";
export { ForwardRef as ReactComponent };